import { QueryClient } from '@tanstack/react-query';

/**
 * Singleton QueryClient for the web app.
 *
 * Defaults are conservative — most consumer data (cart, orders, wallet)
 * is short-lived so we intentionally do not refetch on window focus, which
 * would cause flicker on every tab-switch. Individual queries can override.
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000, // 30s — covers typical navigation patterns
      gcTime: 5 * 60_000, // 5m — keep cache warm after unmount
      refetchOnWindowFocus: false,
      refetchOnReconnect: true,
      retry: (failureCount, error) => {
        // Don't retry auth failures — the api client handles token refresh;
        // if we get a 401 here it means refresh already failed.
        const status = (error as { status?: number })?.status;
        if (status === 401 || status === 403) return false;
        return failureCount < 2;
      },
    },
    mutations: {
      retry: false,
    },
  },
});
